import { Switch, Route } from 'react-router-dom';
import React from 'react';

import PageConstants from 'constants/PageConstants'
import PageParserUtil from 'utils/PageParserUtil'


import TranscriptRoute from './routes/TranscriptRoute';
import ProjectRoute from './routes/ProjectRoute';
import GenericRoute from './routes/GenericRoute';
import TranscriptPrintContainer from './TranscriptPrintContainer';
import ProjectInfoWrapper from './ProjectInfoWrapper';

class NetworkLayer extends React.Component {
  constructor(props) {
    super(props);
    this.state = {};
    this.pageChange = this.pageChange.bind(this);
  }

  componentDidMount() {
    var thisPage = PageParserUtil.parse(this.props.match, this.props.location);
    var that = this;
    setTimeout(function() { // Run after dispatcher has finished
      if ( that )
        that.pageChange(null, thisPage);
    }, 0);
  }

  loadTranscriptPage(transcriptID)
  {
    this.setState({
      transcriptID: transcriptID,
    })
  }

  pageChange(previousPage, nextPage)
  {
    this.setState({
      page: nextPage?.page
    });

    switch (nextPage?.page)
    {
      case PageConstants.ROOT_PAGE:
        this.setState({
          transcriptID: null
        })
      break;
      case PageConstants.PROJECT_PAGE:
      case PageConstants.CODE_BOOK_PAGE:
      case PageConstants.CODE_BOOK_CODE_PAGE:
      case PageConstants.SEARCH_PAGE:
      case PageConstants.NEW_TRANSCRIPT_PAGE:
      case PageConstants.NEW_SURVEY_PAGE:
      {
        const codeID = nextPage.params.codeID;

        this.setState({
          transcriptID: null,
          codeID: codeID,
        })
      }
      break;
      case PageConstants.TRANSCRIPT_PAGE:
      case PageConstants.CODED_BY_ME_PAGE:
      case PageConstants.COMPARISON_PAGE:
      case PageConstants.DEMOGRAPHICS_PAGE:
      {
        if ( nextPage.params.transcriptID )
        {
          this.loadTranscriptPage(nextPage.params.transcriptID);
        }
        else
        {
          this.setState({
            transcriptID: null,
          })
        }
      }
      break;
      case PageConstants.USER_PAGE:
      {
        // TODO: should I wipe it out like this, might be good to not wipe stuff out...
        this.setState({
          transcriptID: null,
        })
      }
      break;
      default: {
        this.setState({
          transcriptID: null
        })
      };
      break;
    }
  }

  UNSAFE_componentWillReceiveProps (nextProps) {
    var nextPage = PageParserUtil.parse(nextProps.match, nextProps.location);
    var thisPage = PageParserUtil.parse(this.props.match, this.props.location);

    if ( !PageParserUtil.isEqual(nextPage, thisPage) )
    {
      var that = this;
      setTimeout(function() { // Run after dispatcher has finished
        that.pageChange(thisPage, nextPage);
      }, 0);
    }
  }



  render() {
    const { transcriptID, page, codeID } = this.state;
    
    return (
      <div>
        <Switch>
          <Route
            path="/transcripts/:transcriptID/print"
            render={() => (
              <div style={{ width: "700px" }}>
                <ProjectInfoWrapper>
                  <TranscriptPrintContainer
                    transcriptID={transcriptID}
                    page={page}
                    {...this.props}
                    width={window.innerWidth}
                    height={window.innerHeight}
                  />
                </ProjectInfoWrapper>
              </div>
            )}
          />
          <Route
            path="/transcripts/:transcriptID/compare"
            render={() => (
              <TranscriptRoute
                transcriptID={transcriptID}
                page={page}
                codeID={codeID}
                rightSideBar={false}
              />
            )}
          />
          <Route
            path="/transcripts/:transcriptID"
            render={() => (
              <TranscriptRoute
                transcriptID={transcriptID}
                page={page}
                codeID={codeID}
                rightSideBar={true}
              />
            )}
          />
          <Route
            path="/surveys/:surveyID"
            render={() => (
              <GenericRoute
                transcriptID={transcriptID}
                page={page}
                codeID={codeID}
                rightSideBar={false}
              />
            )}
          />
          <Route
            path="/survey_responses/:surveyResponseID"
            render={() => (
              <GenericRoute
                transcriptID={transcriptID}
                page={page}
                codeID={codeID}
                rightSideBar={true}
              />
            )}
          />
          <Route
            path="/survey_questions/:surveyQuestionID"
            render={() => (
              <GenericRoute
                transcriptID={transcriptID}
                page={page}
                codeID={codeID}
                rightSideBar={true}
              />
            )}
          />
          <Route
            path="/projects/:projectID/analysis"
            render={() => (
              <ProjectRoute
                page={page}
                codeID={codeID}
                rightSideBar={true}
                requiresExcerpts={true}
              />
            )}
          />
          <Route
            path="/projects/:projectID/chat"
            render={() => (
              <ProjectRoute
                page={page}
                codeID={codeID}
                rightSideBar={true}
                requiresExcerpts={true}
              />
            )}
          />
          <Route 
            path='/users'
            render={() => (
              <GenericRoute
                transcriptID={transcriptID}
                page={page}
                codeID={codeID}
                rightSideBar={false}
              />
            )}
          />
          <Route 
            render={() => (
              <ProjectRoute
                page={page}
                codeID={codeID}
              />
            )}
          />
        </Switch>
      </div>
    );
  }
}

export default NetworkLayer;
